import { Box, Card, Typography } from "@drone-js/core";
import type { FunctionComponent } from "react";

export interface Props {
    number: number;
    text: string;
}

export const CustomCard: FunctionComponent<Props> = ({ number, text }) => (
    // @ts-expect-error gap props works but does not exist in drone-js/core
    <Card variant="outlined" borderRadius="16" p="16" gap="24" display="flex" flexDirection="column" height="100%">
        <Box
            borderColor="feedback.generic.strong"
            borderStyle="solid"
            borderWidth="1"
            borderRadius="max"
            p="8"
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="32px"
            height="32px"
        >
            <Typography variant="body-default-strong">{number}</Typography>
        </Box>
        <Typography variant="body-default">{text}</Typography>
    </Card>
);
